export const getError = state => state.errors.error; // eslint-disable-line
